/*
  Tokyo Romance Club — ABOUT + Service & Trust scroll reveal.
  ABOUT's heading / Japanese body / English copy each reveal as one whole
  unit (never split line-by-line), with heading first, body ~150ms later,
  English copy ~180ms after that. Service & Trust's 5 items are observed
  independently and stagger by ~75ms when several become visible together.
  Once revealed, an element is unobserved and never re-hidden. Never runs
  inside the theme editor.
*/
(function () {
  if (window.__trcAboutMotionInit) return;
  window.__trcAboutMotionInit = true;

  var designMode = document.documentElement.classList.contains('shopify-design-mode');
  if (designMode) return;

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var REVEAL_CLASS = 'trc-ab-in';

  function reveal(el) {
    el.classList.add(REVEAL_CLASS);
  }

  function observeGroup(targets, delayFor) {
    if (targets.length === 0) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries
          .filter(function (entry) {
            return entry.isIntersecting;
          })
          .forEach(function (entry, i) {
            io.unobserve(entry.target);
            window.setTimeout(function () {
              reveal(entry.target);
            }, delayFor(i));
          });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    targets.forEach(function (target) {
      io.observe(target);
    });
  }

  function init() {
    var aboutSection = document.querySelector('[id$="__trc_about"]');
    var serviceSection = document.querySelector('[id$="__trc_service"]');
    if (!aboutSection && !serviceSection) return;

    document.documentElement.classList.add('trc-js');

    if (aboutSection) {
      var aboutTargets = [];
      var heading = aboutSection.querySelector('[class*="__text_heading"]');
      if (heading) aboutTargets.push(heading);
      var bodyJp = aboutSection.querySelector('[class*="__text_jp"]');
      if (bodyJp) aboutTargets.push(bodyJp);
      var bodyEn = aboutSection.querySelector('[class*="__text_en"]');
      if (bodyEn) aboutTargets.push(bodyEn);

      var aboutDelays = [0, 150, 330];
      observeGroup(aboutTargets, function (i) {
        return aboutDelays[i] !== undefined ? aboutDelays[i] : 330;
      });
    }

    if (serviceSection) {
      var serviceTargets = Array.prototype.slice.call(serviceSection.querySelectorAll('.group-block'));
      observeGroup(serviceTargets, function (i) {
        return i * 75;
      });
    }
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
